import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useParams } from 'react-router-dom';
import CapitalContributionsContent from './CapitalContributionsContent';

const EqualiseCapitalContributions: React.FC<{
  baseCurrency: CurrencyCode;
}> = ({ baseCurrency }) => {
  const { selectedVehicleId } = useLayoutContext();
  const { id } = useParams<{ id?: string }>();

  const [equalisation] = api.equalisations.get.useSuspenseQuery({
    equalisationId: id ?? '',
    vehicleId: selectedVehicleId ?? '',
  });

  const selectedCommitments = equalisation.selectedCommitments.filter(
    (commitment) => commitment.commitmentId,
  );

  return (
    <CapitalContributionsContent
      selectedCommitments={selectedCommitments}
      baseCurrency={baseCurrency}
    />
  );
};

export default EqualiseCapitalContributions;
